import { render } from "./DropdownMenu.vue?vue&type=template&id=377e14e5&scoped=true"
import script from "./DropdownMenu.vue?vue&type=script&lang=js"
export * from "./DropdownMenu.vue?vue&type=script&lang=js"

import "./DropdownMenu.vue?vue&type=style&index=0&id=377e14e5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377e14e5"],['__file',"src/components/mdbvue/Components/DropdownMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "377e14e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('377e14e5', __exports__)) {
    api.reload('377e14e5', __exports__)
  }
  
  module.hot.accept("./DropdownMenu.vue?vue&type=template&id=377e14e5&scoped=true", () => {
    api.rerender('377e14e5', render)
  })

}


export default __exports__